import React, { useEffect, useState } from "react";
import CardHeader from "../../Components/shared/CardHeader";
import ReactApexChart from "react-apexcharts";
import { inquiryChannelChartOption } from "../../utils/chartsLogic/inquiryChannelChartOption";
import { fetchFormData } from "../../utils/options";
import { useLocation } from "react-router-dom";

const InquiryChannelChart = (permission) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const fetchMonthlyStatus = async () => {
      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("moduleId", M_id);
      try {
        const response = await fetchFormData(
          "list-montly-status",
          formData,
          "POST"
        );

        if (response?.series) {
          setChartData(response.series);
        }
      } catch (error) {
        console.error("Error fetching monthly status:", error);
      }
    };
    fetchMonthlyStatus();
  }, []);

  const chartOption = inquiryChannelChartOption(chartData);

  return (
    
    <div className="col-xxl-6 ">
      <div className="card stretch stretch-full">
        <CardHeader title="Inquiry Channel" />
        <div className="card-body custom-card-action">
          <div className="leads-inquiry-channel">
            <ReactApexChart
              type="bar"
              options={chartOption}
              series={chartOption.series}
              height={350}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InquiryChannelChart;
